import {fetch} from "utils/dataAccess";
import buildUpdatePayload from "./buildUpdatePayload";

export default async function update(brand, formValues) {
    const response = await fetch(brand["@id"], {
        method: "PUT",
        body: JSON.stringify(buildUpdatePayload(brand, formValues)),
    });

    return await response.json();
}
